import { Route } from '@angular/router';
import { MediumGroupSettingsEditComponent } from 'src/app/pages/media/medium-groups/medium-group-settings-edit/medium-group-settings-edit.component';
import { MediumGroupsComponent } from 'src/app/pages/media/medium-groups/medium-groups.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { MediumGroupEditComponent } from '../../../../../pages/media/medium-groups/medium-group-edit/medium-group-edit.component';
import { MediumGroupCategoryListComponent } from '../../../../../pages/media/medium-groups/mediumGroup-category-list/medium-group-category-list.component';

export const mediumGroups: Route = {
  path: 'medium-groups',
  title: 'nav.motives.motiveGroups',
  data: {
    breadcrumb: 'nav.motives.motiveGroups',
    icon: SbIcons.motives,
    id: RoutingID.mediumGroup,
  },
  children: [
    {
      path: '',
      component: MediumGroupsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'medium-group-edit/:mediumGroupID',
      title: 'nav.motives.motiveGroups.details',
      data: {
        breadcrumb: 'nav.motives.motiveGroups.details',
        icon: SbIcons.edit,
        id: RoutingID.mediumGroupEdit,
      },
      children: [
        {
          path: '',
          component: MediumGroupEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'medium-group-create',
      title: 'nav.motives.motiveGroups.create',
      data: {
        breadcrumb: 'nav.motives.motiveGroups.create',
        icon: SbIcons.plus,
        id: RoutingID.mediumGroupCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: MediumGroupSettingsEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'mediumGroupCategories',
      title: 'lang.globals.mediumGroupCategories',
      data: {
        breadcrumb: 'lang.globals.mediumGroupCategories',
        icon: SbIcons.category,
        id: RoutingID.mediumGroupCategories,
      },
      children: [
        {
          path: '',
          component: MediumGroupCategoryListComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
